<style lang="scss">
  @use "./checkbox";
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/colors";

  .disabled {
    @include colors.background-color(interfaceDisabledGrey_10);
  }
</style>

<script>
  import { onDestroy } from "svelte";
  import Icon from "../Icon.svelte";
  import {
    getMultiCheckboxContext,
    generateCheckboxId,
  } from "./context.svelte";

  let {
    class: cls,
    shape = "square",
    checked = $bindable(),
    hovered = $bindable(false),
    disabled = false,
    ...restProps
  } = $props();

  const id = generateCheckboxId();

  const multiCheckboxContext = getMultiCheckboxContext();
  if (multiCheckboxContext) {
    multiCheckboxContext.add(id, {
      get checked() {
        return checked;
      },
      set checked(value) {
        checked = value;
      },
      get disabled() {
        return disabled;
      },
    });

    onDestroy(() => {
      multiCheckboxContext.delete(id);
    });
  }

  let ariaChecked = $derived(checked ? "true" : "false");

  const ICONS = {
    true: "fa-regular fa-check",
    mixed: "fa-regular fa-minus",
    false: "",
  };

  let icon = $derived(
    [
      hovered && !disabled ? "fa-regular fa-check" : ICONS[ariaChecked] || "",
      disabled ? "background-color-interfaceDisabledGrey_10" : "",
    ].join(" ")
  );

  const toggle = () => {
    checked = !checked;
  };
  const onclick = (e) => {
    toggle();
    e.stopPropagation();
  };
  const onmouseenter = () => {
    hovered = true;
    if (restProps.onmouseenter) {
      restProps.onmouseenter();
    }
  };
  const onmouseleave = () => {
    hovered = false;
    if (restProps.onmouseleave) {
      restProps.onmouseleave();
    }
  };
  const onfocus = () => {
    hovered = true;
    if (restProps.onfocus) {
      restProps.onfocus();
    }
  };
  const onblur = () => {
    hovered = false;
    if (restProps.onblur) {
      restProps.onblur();
    }
  };
</script>

<button
  class="{cls} {shape}"
  class:hovered
  class:disabled
  {onclick}
  {onmouseenter}
  {onmouseleave}
  {onfocus}
  {onblur}
  {...restProps}
  role="checkbox"
  aria-checked={ariaChecked}
  {disabled}
>
  <Icon class={icon} size="small" />
</button>
